module.exports = __webpack_public_path__ + "img/card-logo.6991a0dc.png";